export default __webpack_public_path__ + "static/media/pile 3 1.d0c0b547.png";